import { __decorate } from "tslib";
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationSnackbarStyles as styles } from './snackbar.styles';
import { foundationSnackbarTemplate as template } from './snackbar.template';
export const foundationSnackbarShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
const CLOSE_TIMEOUT = 10000;
/**
 * @tagname %%prefix%%-snackbar
 */
export class Snackbar extends FoundationElement {
    constructor() {
        super(...arguments);
        this.deleteAnimation = '';
        this.closeTimeout = CLOSE_TIMEOUT;
        this.autoClose = true;
        this.type = '';
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.autoClose) {
            setTimeout(() => {
                this.deleteAnimation = 'snackbar-delete';
                this.snackbar.onanimationend = () => {
                    this.dismiss();
                };
            }, this.closeTimeout);
        }
    }
    errorChanged(oldValue, newValue) {
        var _a, _b, _c;
        this.type = (_c = (_b = (_a = newValue === null || newValue === void 0 ? void 0 : newValue.config) === null || _a === void 0 ? void 0 : _a.snackbar) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : '';
    }
    notificationChanged(oldValue, newValue) {
        var _a, _b, _c;
        this.type = (_c = (_b = (_a = newValue === null || newValue === void 0 ? void 0 : newValue.config) === null || _a === void 0 ? void 0 : _a.snackbar) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : '';
    }
    /**
     * Remove the snackbar from display.
     */
    dismiss() {
        this.remove();
    }
}
__decorate([
    observable
], Snackbar.prototype, "error", void 0);
__decorate([
    observable
], Snackbar.prototype, "notification", void 0);
__decorate([
    observable
], Snackbar.prototype, "deleteAnimation", void 0);
__decorate([
    attr({ attribute: 'close-timeout' })
], Snackbar.prototype, "closeTimeout", void 0);
__decorate([
    attr({ attribute: 'auto-close' })
], Snackbar.prototype, "autoClose", void 0);
__decorate([
    attr({ attribute: 'type' })
], Snackbar.prototype, "type", void 0);
/**
 * The Foundation Snackbar
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-snackbar\>
 */
export const foundationSnackbar = Snackbar.compose({
    baseName: 'snackbar',
    styles,
    template,
    shadowOptions: foundationSnackbarShadowOptions,
});
